import React, { Component}   from 'react';
import { Link } from 'react-router-dom';
import { Button , Glyphicon } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import cellEditFactory from 'react-bootstrap-table2-editor';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import HomeTable from '../Home/HomeTable';
import { db } from '../../firebase';
import _ from 'underscore';
import lodash from 'lodash';
import firebase from 'firebase';

import '../css/main.css';

let size = 0 , childId;

const rankFormatter = ( cell, row, rowIndex, formatExtraData) => {
  return (
    <img src={cell} style={{width : '100%'}} alt="User Image"/>
  );
}

const cellFormater = (cell, row, rowIndex, formatExtraData) => {
  return (
    <span style={{wordBreak : 'break-all', textTransform : "capitalize"}}>{cell}</span>
  );
}


const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing { from } to { to } of { size } Results
    </span>
);

const defaultSorted = [{
  dataField: 'users_count',
  order: 'desc'
}];

const options = {
  paginationSize: 5,
  pageStartIndex: 0,
  // alwaysShowAllBtns: true, // Always show next and previous button
  // withFirstAndLast: false, // Hide the going to First and Last page button
  // hideSizePerPage: true, // Hide the sizePerPage dropdown always
  hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
  alwaysShowAllBtns: false, 
  firstPageText: 'First',
  prePageText: null,
  nextPageText: null,
  lastPageText: 'Last',
  // nextPageTitle: 'First page',
  prePageTitle: 'Pre page',
  firstPageTitle: 'Next page',
  // lastPageTitle: 'Last page',
  showTotal: true,
  paginationTotalRenderer: customTotal,
  sizePerPageList: [{
    text: '5', value: 5
  }, {
    text: '10', value: 10
  }, {
    text: '15', value: 15
  }, {
    text: '25', value: 25
  }, {
    text: '50', value: 50
  }, {
    text: '100', value: 100
  }
  ] 
};

const cellEdit = cellEditFactory({
    mode: 'click',
    afterSaveCell : (oldValue, newValue, row, column) => { 
      firebase.database().ref('users/vendors').child(row.id).child('details').set(row);
    },
    blurToSave : true
});


class AdminTable extends Component {
  columns = [
    {
      dataField: 'users_count',
      text: 'Users Count',
      sort : true,
      formatter : this.renderButton
    },
    {
      dataField: 'id',
      text: 'ID',
      sort : true,
      formatter : cellFormater
    },
    {
      dataField: 'name',
      text: 'Name',
      sort : true,
      formatter : cellFormater
    }, {
      dataField: 'contact',
      text: 'Contact',
      editable : false,
      formatter : cellFormater
    }, {
      dataField: 'aadhar_no',
      text: 'Aadhar',
      formatter : cellFormater
    }, {
      dataField: 'pan_no',
      text: 'Pan Number',
      formatter : cellFormater
    }, {
      dataField: 'working_area',
      text: 'Working Area',
      formatter : cellFormater
    }, {
      dataField: 'panchayat_block',
      text: 'Panchayat Block',
      formatter : cellFormater
    }
  ];

  
  constructor(props){
    super(props);
    this.state = {
      childUid : window.childId,
      showParent : true,
    }
  }

  componentDidMount(){
    var self = this , date = new Date() , temp = {}; 
    var timestamp = date.getTime();
    this.setState({
      filename : "Data_"+timestamp+".csv",
    })
  }

  renderUserTable( id){
    this.setState({
      uid : id
    })
  }

  renderButton = (cell, row, rowIndex, formatExtraData) => {
    return(<button style={{wordBreak : 'break-all', textTransform : "capitalize"}} onClick={ () => this.renderUserTable(row.id)}>Check Users</button>)
  }

  rowEvents = {
    onClick: (e, row, rowIndex) => {
      this.setState({
        uid : row.id,
        showParent : false
      })
    }
  };

  render(){
    return(
      <div className=" m-r-10">
        <div style={{display : 'flex', justifyContent : 'space-between', alignItems : 'center'}}>
          <div className="welcome_user m-t-20" style={{color : '#F2994A'}}>Total No. of Vendors : {this.props.data? this.props.data.length : null}</div>
      </div>
        <div className="card_details m-40">
        {this.props.data && this.state.showParent? 
          <BootstrapTable
            keyField='uid' 
            data={ this.props.data } 
            columns={ this.columns } 
            cellEdit={ cellEdit}
            bootstrap4={true} 
            noDataIndication ={true}
            loading={true} 
            paginationFactory = {paginationFactory(options)}
            hover={true}
            rowEvents={ this.rowEvents }          
            striped
            defaultSorted = {defaultSorted}
          >
          </BootstrapTable> :null          
          }
          {this.state.uid  ? 
          <div>
            <div> 
              <Button onClick={() => this.setState({showParent : true , uid :''})} bsStyle="link">
                <Glyphicon glyph="arrow-left" /> Back
              </Button> 
            </div>
            <HomeTable uid={this.state.uid} show /> 
          </div>: null}
        </div>
      </div>
    )
  }
}
export default AdminTable;